import React from 'react';
import { Box, Container, Heading, Text, VStack, SimpleGrid } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const ExperiencedTechStack = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.800">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="white">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="whiteAlpha.800" maxW="2xl">
              {data.description}
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 2, md: 4 }} spacing={6} w="full">
            {data.technologies.map((tech, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Box
                  p={6}
                  bg="whiteAlpha.100"
                  borderRadius="xl"
                  textAlign="center"
                  _hover={{
                    bg: 'whiteAlpha.200',
                    transform: 'translateY(-4px)',
                  }}
                  transition="all 0.3s"
                >
                  <VStack spacing={2}>
                    <Text fontWeight="700" fontSize="lg" color="white">
                      {tech.name}
                    </Text>
                    <Text fontSize="sm" color="accent.gold">
                      {tech.category}
                    </Text>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default ExperiencedTechStack;